import React from 'react';

const formatDate = (value) => {
  if (!value) return null;
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return value;
  return date.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric', hour: 'numeric', minute: '2-digit' });
};

const FundingSubmissionTimeline = ({ submission }) => {
  const events = [
    { label: 'Created', at: submission.createdAt },
    { label: 'Submitted', at: submission.submittedAt },
    { label: 'Under review', at: submission.underReviewAt },
    { label: 'Approved', at: submission.approvedAt },
    { label: 'Declined', at: submission.declinedAt },
    { label: 'Funded', at: submission.fundedAt },
  ].filter((event) => event.at);

  if (!events.length) {
    return <p className="text-sm text-[var(--fg-muted)]">No status timeline events yet.</p>;
  }

  return (
    <div className="space-y-2">
      <div className="text-sm font-semibold text-[var(--fg-text)]">Status timeline</div>
      {events.map((event) => (
        <div key={event.label} className="flex items-center justify-between rounded-xl border border-[var(--fg-line)] bg-white px-3 py-2 text-sm dark:bg-slate-950/20">
          <span className="text-[var(--fg-text)]">{event.label}</span>
          <span className="text-[var(--fg-muted)]">{formatDate(event.at)}</span>
        </div>
      ))}
    </div>
  );
};

export default FundingSubmissionTimeline;
